var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(
              _vm._s(_vm.$t("components.label-layout-editor.upload-json.title"))
            ),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-file-upload", {
                        attrs: {
                          label: _vm.$t(
                            "components.label-layout-editor.upload-json.file"
                          ),
                          "allowed-extensions": ["json"],
                        },
                        on: {
                          input: function ($event) {
                            _vm.file = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.file
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-link",
                            {
                              staticClass: "link",
                              on: {
                                click: function ($event) {
                                  _vm.file = null
                                },
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.file.name)),
                              _c("w-fa", {
                                staticClass: "ml",
                                attrs: { icon: "times" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: _vm.file == null },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }